<template>
	<div class="limit-bar">
		<div class="limit-bar__head">
			<span class="limit-bar__title">{{ title }}</span>
			<span class="limit-bar__value">{{ used }} / {{ limit }}</span>
		</div>
		<div class="limit-bar__track">
			<div class="limit-bar__fill" :style="{ width: `${percent}%` }"></div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
	title: string
	used: number
	limit: number
}>()

const percent = computed(() => {
	if (props.limit <= 0) return 0
	return Math.min(100, Math.max(0, (props.used / props.limit) * 100))
})
</script>

<style lang="scss" scoped>
.limit-bar {
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 12px;
	&__head {
		@include flex-space-between;
		gap: 8px;
	}
	&__title {
		font: var(--font-label);
		color: var(--text-primary);
	}
	&__value {
		font: var(--font-body-small);
		color: var(--text-secondary);
		text-align: right;
		white-space: nowrap;
	}
	&__track {
		width: 100%;
		height: 8px;
		background-color: var(--background-track);
		border-radius: var(--radius-sm);
		overflow: hidden;
	}
	&__fill {
		height: 100%;
		background-color: var(--action-primary);
		border-radius: var(--radius-sm);
		transition: width 0.3s ease-in-out;
	}
}
</style>
